export const FAILED = 'Home/failed';
export const LOADING = 'Home/loading';
export const SUCCESS = 'Home/success';
